import Tooltip from '@mui/material/Tooltip';
import Link from 'studio/components/Link';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LaunchIcon from '@mui/icons-material/LaunchRounded';

import { useLocation, useRouteMatch } from 'react-router-dom';

import sx from './Menu.styles';

const MenuItem = ({ item, expand, isChildItem = false, setOpen }) => {
  const location = useLocation();

  // match the current path (this takes into consideration the context path)
  const match = useRouteMatch({
    path: location.pathname,
    exact: true
  });

  const Icon = item.icon;
  const linkProps = item.href
    ? {
        component: Link,
        href: item.href,
        knowledgeGraph: item.knowledgeGraph,
        newWindow: item.newWindow
      }
    : {};

  const handleClick = event => {
    // If this is a top-level item (not a child) and it has an href, close other dropdowns
    if (!isChildItem && item.href && !item.items?.length) {
      // Close all dropdowns when navigating to a different section
      setOpen({});
    }

    // Call the original onClick if it exists
    if (item.onClick) {
      item.onClick(event);
    }
  };

  return (
    <Tooltip title={item.tooltip || ''} placement="right" arrow>
      <ListItem disablePadding>
        <ListItemButton
          dense
          selected={match.path === item.href}
          color="inherit"
          {...linkProps}
          data-value={item.href}
          onClick={handleClick}
          disabled={item.disabled}
        >
          <ListItemIcon sx={sx.icon}>
            <Icon />
          </ListItemIcon>
          <ListItemText primary={item.title} />
          {item.newWindow && <LaunchIcon color="disabled" />}
          {expand}
        </ListItemButton>
      </ListItem>
    </Tooltip>
  );
};

export default MenuItem;
